import {RefObject, useEffect, useRef} from 'react';

export default function useIntersection(
  {
    targetRef,
    options,
    onIntersection,
  }: {
    targetRef: RefObject<HTMLElement>;
    options?: IntersectionObserverInit;
    onIntersection?: (isIntersecting: boolean) => void;
  },
  isDisable?: boolean
) {
  const callbackRef = useRef(onIntersection);
  useEffect(() => {
    callbackRef.current = onIntersection;
  }, [onIntersection]);

  useEffect(() => {
    const targetEl = targetRef.current;

    if (isDisable || !targetEl) return;

    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === targetEl) {
          callbackRef.current?.(entry.isIntersecting);
        }
      }
    }, options);

    observer.observe(targetEl);
    return () => {
      observer.disconnect();
    };
  }, [options, targetRef, isDisable]);
}
